import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

const ArchiveMaterialCategoryModal = ({ name = "", onCancel, onConfirm }) => {
  return (
    <div className="fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-30">
      <OutsideClickHandler onOutsideClick={onCancel}>
        <div className="flex w-[360px] flex-col rounded-[6px] bg-[#ffecec] p-[18px] shadow-lg">
          <p className="mb-3 text-[16px] font-OpenSansMedium font-[600] text-titleColor">ARCHIVE MATERIAL</p>
          <p className="text-[12px] font-OpenSansRegular text-titleColor">
            Do you want to archive this material category? It will disappear from the list of options when creating new
            service tickets.
          </p>
          <p className="mt-3 text-center text-[16px] font-OpenSansMedium text-titleColor">{name}</p>
          <div className="mt-4 flex items-center justify-between gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex h-[36px] w-[50%] items-center justify-center rounded-[6px] border border-subTitleColor text-[12px] font-OpenSansMedium text-titleColor"
            >
              CANCEL
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="flex h-[36px] w-[50%] items-center justify-center rounded-[6px] bg-[#d14343] text-[12px] font-OpenSansMedium text-white"
            >
              ARCHIVE
            </button>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default ArchiveMaterialCategoryModal;
